<template>
  <div class="object">
    <div class="object-bar d-flex justify-space-between">
      <h3>{{ title }}</h3>
      <v-icon>mdi-plus</v-icon>
    </div>
    <div class="object-content">
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus
        sapiente tempora quibusdam, officia officiis voluptatibus itaque libero
        nobis dignissimos dolor rem facilis sequi excepturi quia perspiciatis
        explicabo perferendis, quam esse.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: ["title"],
};
</script>

<style scoped>
.object{
  display: flex;
  flex-direction: column;
  max-height: 400px;
}
.object-bar {
  padding: 1rem;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.object-content {
  padding: 2rem;
}

.object-content p {
  font-size: clamp(.5rem, 2.5vw, 1rem);
}

.object:hover .v-icon{
  transform: rotate(180deg) !important;
  color: #ffbf00;
  transition: all .4s ease;
}
</style>
